import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import LoginPage from "../pages/Authentication/LoginPage.vue";
import LogOutPage from "../pages/Authentication/LogOutPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import ForgetPasswordPage from "../pages/Authentication/ForgetPasswordPage.vue";
import ConfirmMailPage from "../pages/Authentication/ConfirmMailPage.vue";
import InternalErrorPage from "../pages/Error/InternalErrorPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import TournamentsPage from "../pages/Admin/Tournaments/TournamentsPage.vue";
import TournamentsCreate from "../pages/Admin/Tournaments/TournamentView.vue";
import MatchesPage from "../pages/Admin/Matches/MatchPage.vue";
import MatchesCreate from "../pages/Admin/Matches/MatchView.vue";
import PlaysPage from "../pages/Admin/Plays/PlayPage.vue";
import PlaysCreate from "../pages/Admin/Plays/PlayView.vue";
import PlayConfig from "../pages/Admin/Plays/PlayConfigView.vue";
import PlayersPage from "../pages/Admin/Players/PlayersPage.vue";
import PlayersCreate from "../pages/Admin/Players/PlayerView.vue";
import UsersPage from "../pages/Configuration/Users/UsersPage.vue";
import UsersCreate from "../pages/Configuration/Users/UsersView.vue";
import RepositoryPage from "../pages/Admin/Repository/RepositoryPage.vue";
import RepositoryCreate from "../pages/Admin/Repository/RepositoryView.vue";
import QuestionsPage from "../pages/Admin/Questions/QuestionsPage.vue";
import QuestionsCreate from "../pages/Admin/Questions/QuestionsView.vue";
import TeamsPage from "../pages/Admin/Teams/TeamsPage.vue";
import TeamsCreate from "../pages/Admin/Teams/TeamView.vue";
import CompaniesPage from "../pages/Admin/Companies/CompaniesPage.vue";
import CompanyCreate from "../pages/Admin/Companies/CompanyView.vue";
import PromotorsPage from "../pages/Admin/Promotors/PromotorsPage.vue";
import PromotorCreate from "../pages/Admin/Promotors/PromotorsView.vue";
import PlayerComplaintsPage from "../pages/Admin/PlayerComplaints/PlayerComplaintsPage.vue";
import PrizesPage from "../pages/Admin/Prizes/PrizesPage.vue";
import PrizeCreate from "../pages/Admin/Prizes/PrizeView.vue";
import ChangePasswordPage from "@/pages/Settings/ChangePasswordPage.vue";
import MyProfilePage from "@/pages/Settings/MyProfilePage.vue";
import TournamentTeamsPlayersPage from "@/pages/Admin/Reports/TournamentTeamsPlayers.vue";
import TournamentStatisticsPage from "@/pages/Admin/Reports/TournamentStatistics.vue";
import TournamentPlayerDataPage from "@/pages/Admin/Reports/TournamentPlayerData.vue";
import TournamentPlayersPrizePage from "@/pages/Admin/Reports/TournamentPlayersPrize.vue";
import PlaysContentPage from "@/pages/Admin/Queries/PlaysContent.vue";
import PlaysOptionsCreate from "../pages/Admin/Plays/Options/PlayOptionView.vue";
import NotificationsPage from "../pages/Admin/Notifications/NotificationsPage.vue";
import NotificationCreate from "../pages/Admin/Notifications/NotificationView.vue";
import PasswordRecoverPage from "../pages/Authentication/PasswordRecoverPage.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "LoginPageRoot",
    component: LoginPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/tournaments",
    name: "TournamentsPage",
    component: TournamentsPage,
  },
  {
    path: "/tournament/create",
    name: "TournamentsCreate",
    component: TournamentsCreate 
  },
  {
    path: "/tournament/edit/:id?",
    name: "TournamentsEdit",
    component: TournamentsCreate,
    props: true
  },
  {
    path: "/matches",
    name: "MatchesPage",
    component: MatchesPage,
  },
  {
    path: "/match/create",
    name: "MatchesCreate",
    component: MatchesCreate 
  },
  {
    path: "/match/edit/:id?",
    name: "MatchesEdit",
    component: MatchesCreate,
    props: true
  },

  {
    path: "/plays",
    name: "PlaysPage",
    component: PlaysPage,
  },
  {
    path: "/play/create",
    name: "PlaysCreate",
    component: PlaysCreate 
  },
  {
    path: "/play/edit/:id?",
    name: "PlaysEdit",
    component: PlaysCreate,
    props: true
  },
  {
    path: "/play/config/:id?",
    name: "PlayConfig",
    component: PlayConfig,
    props: true
  },
  {
    path: "/players",
    name: "PlayersPage",
    component: PlayersPage,
  },
  {
    path: "/player/create",
    name: "PlayersCreate",
    component: PlayersCreate 
  },
  {
    path: "/player/edit/:id?",
    name: "PlayersEdit",
    component: PlayersCreate,
    props: true
  },
  {
    path: "/users",
    name: "UsersPage",
    component: UsersPage,
  },
  {
    path: "/user/create",
    name: "UsersCreate",
    component: UsersCreate 
  },
  {
    path: "/user/edit/:id?",
    name: "UsersEdit",
    component: UsersCreate,
    props: true
  },

  {
    path: "/repository",
    name: "RepositoryPage",
    component: RepositoryPage,
  },
  {
    path: "/play-type/create/:idPlay?",
    name: "PlayTypeCreate",
    component: RepositoryCreate 
  }, 
  {
    path: "/play-type/:type/edit/:id?",
    name: "PlayTypeEdit",
    component: RepositoryCreate,
    props: true
  },
  {
    path: "/repository/create/:idPlay?",
    name: "RepositoryCreate",
    component: RepositoryCreate 
  },
  {
    path: "/repository/:type/edit/:id?",
    name: "RepositoryEdit",
    component: RepositoryCreate,
    props: true
  },
  {
    path: "/play-type/:type/edit/:id?/option/:opid?",
    name: "PlaysOptionEdit",
    component: PlaysOptionsCreate,
    props: true
  },
  {
    path: "/questions",
    name: "QuestionsPage",
    component: QuestionsPage,
  },
  {
    path: "/question/create",
    name: "QuestionsCreate",
    component: QuestionsCreate 
  },
  {
    path: "/question/edit/:id?",
    name: "QuestionsEdit",
    component: QuestionsCreate,
    props: true
  },

  
  {
    path: "/teams",
    name: "TeamsPage",
    component: TeamsPage,
  },
  {
    path: "/team/create",
    name: "TeamsCreate",
    component: TeamsCreate 
  },
  {
    path: "/team/edit/:id?",
    name: "TeamsEdit",
    component: TeamsCreate,
    props: true
  },
  {
    path: "/companies",
    name: "CompaniesPage",
    component: CompaniesPage,
  },
  {
    path: "/company/create",
    name: "CompanyCreate",
    component: CompanyCreate 
  },
  {
    path: "/company/edit/:id?",
    name: "CompanyEdit",
    component: CompanyCreate,
    props: true
  },
  {
    path: "/promotors",
    name: "PromotorsPage",
    component: PromotorsPage,
  },
  {
    path: "/promotor/create",
    name: "PromotorCreate",
    component: PromotorCreate 
  },
  {
    path: "/promotor/edit/:id?",
    name: "PromotorEdit",
    component: PromotorCreate,
    props: true
  },  
  {
    path: "/player-complaints",
    name: "PlayerComplaintsPage",
    component: PlayerComplaintsPage,
  },
  {
    path: "/prizes",
    name: "PrizesPage",
    component: PrizesPage,
  },
  {
    path: "/prize/create",
    name: "PrizesCreate",
    component: PrizeCreate 
  },
  {
    path: "/prize/edit/:id?",
    name: "PrizesEdit",
    component: PrizeCreate,
    props: true
  },
  {
    path: "/reports/tournament-teams-and-players",
    name: "TournamentTeamsPlayersPage",
    component: TournamentTeamsPlayersPage,
  },
  {
    path: "/reports/tournament-statistics",
    name: "TournamentStatisticsPage",
    component: TournamentStatisticsPage,
  },
  {
    path: "/reports/tournament-player-data",
    name: "TournamentPlayerDataPage",
    component: TournamentPlayerDataPage,
  },  
  {
    path: "/reports/tournament-players-prizes",
    name: "TournamentPlayersPrizePage",
    component: TournamentPlayersPrizePage,
  }, 
  {
    path: "/queries/plays-content",
    name: "PlaysContentPage",
    component: PlaysContentPage,
  },
  {
    path: "/authentication/logout",
    name: "LogOutPage",
    component: LogOutPage,
  },
  {
    path: "/reset-password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
  },
  {
    path: "/authentication/forget-password",
    name: "ForgetPasswordPage",
    component: ForgetPasswordPage,
  },
  {
    path: "/authentication/confirm-mail",
    name: "ConfirmMailPage",
    component: ConfirmMailPage,
  },
  {
    path: "/settings/my-profile",
    name: "MyProfilePage",
    component: MyProfilePage,
  },
  {
    path: "/settings/change-password",
    name: "ChangePasswordPage",
    component: ChangePasswordPage,
  },
  {
    path: "/error/internal-error",
    name: "InternalErrorPage",
    component: InternalErrorPage,
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
  },
  {
    path: "/notification/edit/:id?",
    name: "NotificationEdit",
    component: NotificationCreate,
    props: true
  },
  {
    path: "/authentication/password-recover",
    name: "PasswordRecoverPage",
    component: PasswordRecoverPage,
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});


router.beforeEach((to, from, next) => {
  
  const publicPages = ['/', '/login', '/authentication/reset-password']; // pages that don't require redirection
  
  const forcePasswordChange = localStorage.getItem("forcePasswordChange") ;
  // Prevent infinite redirect loop
  const isChangingPassword = to.path === '/reset-password';

  const isPublicPage = publicPages.includes(to.path);

  if (forcePasswordChange == "true" && !isChangingPassword && !isPublicPage) {
    return next('/reset-password');
  }
  next();
});
export default router;
